import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import GraficoSinal from '@/layouts/components/custom/GraficoSinal.vue'
import GraficoSinalFut from '@/layouts/components/custom/GraficoSinalFut.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(GraficoSinal.name, GraficoSinal)
Vue.component(GraficoSinalFut.name, GraficoSinalFut)
